module.exports = __webpack_public_path__ + "static/media/website-06.2c3254d7.png";